import React from 'react';
import moment from 'moment';
import { Form } from 'components';
import './style.scss';

function DocumentRowEditor({ document, onChange, formRef }) {
  return (
    <div className="student-documents-inline-editor-row-container">
      <strong>Edit Document</strong>
      <Form
        ref={formRef}
        className="student-documents-inline-editor-row-fields"
        onChange={(values) => onChange(values)}
        validateOn="submit"
      >
        <div className="student-documents-inline-editor-row-fields-name">
          <label className="student-documents-inline-editor-row-label">
            Document Name
          </label>
          <Form.Input
            placeholder="Document Name"
            defaultValue={document.title}
            name="title"
            required
            autoFocus
            tabIndex={0}
          />
        </div>
        <div className="student-documents-inline-editor-row-fields-expiry">
          <label className="student-documents-inline-editor-row-label">
            Expiry Date
          </label>
          <Form.DatePicker
            className="student-documents-inline-editor-row-fields-datepicker"
            defaultValue={
              document.expiry_date
                ? moment(document.expiry_date).toDate()
                : ''
            }
            name="expiry_date"  
            disablePast
            tabIndex={1}
          />
        </div>
      </Form>
    </div>
  );
}

export default DocumentRowEditor;
